import type { JSX } from 'react';

import { VictoryIcon } from '@change/ds-icons';

import { Card, Image, Text } from '@change/ds-core-ui/next';

import { Translate } from '@change-corgi/core/react/i18n';

import { BG_IMPACT_GRID_IMAGE } from 'src/app/pages/about/impact/shared/consts';

export function VictoryHighlight(): JSX.Element {
	return (
		<div className="border-border-strong relative mx-auto flex aspect-square max-h-[420px] w-full max-w-full items-center justify-center overflow-hidden border md:aspect-[3/1]">
			<Image src={BG_IMPACT_GRID_IMAGE} alt="" className="absolute inset-0 h-full w-full object-cover" />
			<Card className="bg-fill-inverse-strong relative z-10 flex max-w-sm flex-col items-center justify-center px-8 py-10">
				<VictoryIcon size="x-large" gradient />
				<Text as="h3" size="x-small" variant="heading" className="mt-4 text-center">
					<Translate value="fe.pages.impact.victories.every_hour" />
				</Text>
			</Card>
		</div>
	);
}
